import notEmptyAttribute from '@model/_shared/validator/notEmptyAttribute'
import notEmptySelfOrTarget from '@model/_shared/validator/notEmptySelfOrTarget'

export const validators = {
  name: notEmptyAttribute,
  serial: notEmptySelfOrTarget,
  numberCommission: notEmptySelfOrTarget,
  product: notEmptyAttribute,
  installedAt: notEmptyAttribute,
}

export {
  validators as default,
  notEmptyAttribute,
}
